import { render, staticRenderFns } from "./VendorCommodities.vue?vue&type=template&id=1b1e8a9a&"
import script from "./VendorCommodities.vue?vue&type=script&lang=js&"
export * from "./VendorCommodities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports